import { createBrowserHistory } from 'history';

/**
 * BrowserHistory.
 */
const history = createBrowserHistory();
export default history;
